export default "__VITE_ASSET__pjILhu$N__"